export default {
  // General TR5
  'tr5.odometer': 'Odomètre',
  'tr5.year': 'Année',
  'tr5.controls.sendToClosing': 'Envoyer en Fermeture',
  'tr5.controls.sendToLost': 'Envoyer vers Non vendu',

  // TRD
  'trd.description': 'Transport direct',
  'trd.tooltip':
    'Le vendeur a choisi d’utiliser le Transport Direct exclusivement. Voir les informations sur les tarifs.',
  'trd.tooltip.promo':
    'Le vendeur a choisi d’utiliser le Transport Direct exclusivement. Voir les informations promotionnelles.',

  // General VDP
  'vdp.asis': 'Tel quel',
  'vdp.highbid': 'Enchère élevéate!',
  'vdp.outbid': 'Dépassé',
  'vdp.floorMet': 'Seuil atteint',
  'vdp.floorPrice': 'Prix Plancher',
  'vdp.hasFloorPrice': 'Plancher établi',
  'vdp.closeToFloorPrice': 'Près du Plancher',
  'vdp.auctionEnded': 'Encan terminé',
  'vdp.pendingEnded': 'Terminé',
  'vdp.closingEnded': 'Fermeture Terminée',
  'vdp.headerViews': '114 vues',
  'vdp.rateInfo': 'Info Tarif.',
  'vdp.transportPromoOn': 'Promotion en cours!',
  'vdp.transportPromoInfoLong': 'Infos sur tarifs promotionnels',
  'vdp.transportValueEstimated': 'estimé',
  'vdp.seller.detailsShownToBuyer': "Informations divulguées à l'acheteur",

  // Pending Closing VDP
  'vdp.closing.buyer.disclaimer':
    "En plaçant une offre, vous confirmez que vous avez examiné la page de détails du véhicule et le rapport sur l'historique du véhicule.",
  'vdp.pending.buyer.button.reply': 'Répondre',
  'vdp.pending.buyer.button.startNegotiation': 'Commencer les négotiations',
  'vdp.pending.buyer.button.viewNegotiation': 'Voir les négotiations',
  'vdp.pending.buyer.button.view': 'VISUALISER',
  'vdp.pending.buyer.declined': 'Refusé',
  'vdp.pending.buyer.label.buyerCounter': 'Votre contreproposition',
  'vdp.pending.buyer.label.buyerFirm': 'Ferme à',
  'vdp.pending.buyer.label.buyerOffer': 'Votre offre',
  'vdp.pending.buyer.label.finalAskingPrice': 'Prix final demandé',
  'vdp.pending.buyer.label.newAsking': 'Nouveau prix demandé',
  'vdp.pending.buyer.label.nowInActive': 'Maintenant sous Enchère active',
  'vdp.pending.buyer.label.nowInUpcoming': 'Maintenant sous À Venir',
  'vdp.pending.buyer.label.sellerCounter': 'Nouvelle contreproposition',
  'vdp.pending.buyer.label.sellerOffer': 'Nouveau prix demandé',
  'vdp.pending.buyer.label.sentToSecondBidder': 'Envoyer au 2e offrant',
  'vdp.pending.buyer.label.yourOffer': 'Votre offre',
  'vdp.pending.buyer.label.yourTopBid': 'Votre meilleure offre',
  'vdp.pending.seller.button.reply': 'Répondre',
  'vdp.pending.seller.button.sendToClosing': 'Envoyer en Fermeture',
  'vdp.pending.seller.button.startNegotiation': 'Commencer les négotiations',
  'vdp.pending.seller.button.viewNegotiation': 'VISUALISER',
  'vdp.pending.seller.label.buyerCounter': 'Nouvelle contreproposition',
  'vdp.pending.seller.label.buyerFirm': 'Acheteur ferme à',
  'vdp.pending.seller.label.buyerOffer': 'Nouvelle offre',
  'vdp.pending.seller.label.finalAskingPrice': 'Votre prix final demandé',
  'vdp.pending.seller.label.sellerCounter': 'Vous demandez',
  'vdp.pending.seller.label.sellerOffer': 'Vous demandez',

  // Confirmation Modals
  'vdp.confirmation.title.sameDealership':
    'Quelqu’un à votre concessionnaire est déjà le meilleur offrant sur ce véhicule.',
  'vdp.confirmation.title.sameDealershipMessage':
    'Les enchérisseurs de même concessionnaires n’iront pas en Fermeture ensemble. Désirez-vous quand même soumettre une offre?',
  'vdp.confirmation.title.sameDealerGroup':
    'Un autre membre de votre groupe de concessionnaires est actuellement le premier enchérisseur pour ce véhicule.',
  'vdp.confirmation.msg.submitBid':
    'Souhaitez-vous toujours soumettre votre offre?',
  'vdp.confirmation.title.bidSeemsHigh':
    'Votre offre de {bidAmount} semble trop élevée.',
  'vdp.confirmation.title.startingBidSeemsHigh':
    'Votre offre de départ de {bidAmount} semble être élevée. ',
  'vdp.confirmation.msg.confirmBidAmount':
    'Souhaitiez-vous saisir une offre de départ de {bidAmount}? Si tel est le cas, vous pouvez continuer ci-dessous.',
  'vdp.confirmation.title.proxySeemsHigh':
    'Votre offre maximale de {proxyAmount} semble élevée.',
  'vdp.confirmation.msg.confirmProxyAmount':
    'Souhaitiez-vous saisir une offre maximale de {proxyAmount}? Si tel est le cas, vous pouvez continuer ci-dessous.',
  'vdp.confirmation.yesBid': 'Oui, miser',

  // Toaster Error Messages
  'vdp.error.startingBidLow':
    'L’offre de départ que vous avez présentée est trop faible. Saisissez une offre de départ d’au moins {minBidAmount}',
  'vdp.error.bidTooLow':
    'Le montant de votre offre est trop faible. Veuillez saisir un montant supérieur à la meilleure offre actuelle.',
  'vdp.error.startingBidLargerThanProxy':
    'Votre offre de départ est plus élevée que votre offre maximale (proxy). Veuillez saisir une offre de départ inférieure au montant de votre offre maximale (proxy).',
  'vdp.error.wrongBidIncrement':
    'Votre offre était dans le mauvais incrément. Veuillez enchérir sur ce véhicule par tranches de {quickBidIncrement}',
  'vdp.error.noStartingBid':
    "Veuillez saisir un montant pour l'offre de départ.",
  'vdp.error.noBid': 'Veuillez saisir un montant d’enchère.',
  'vdp.error.noProxy': 'Veuillez saisir une offre maximale (proxy).',
  'vdp.error.noProxyNoStartingBid':
    "Vous n’avez pas saisi une offre maximale (proxy). Veuillez saisir un montant de départ ainsi qu'un montant maximal (proxy).",
  'vdp.error.proxyTooLow':
    "L'offre maximale que vous avez saisi est trop faible. Entrez une offre maximale d’au moins {minProxyAmount}",
  'vdp.error.wrongProxyIncrement':
    'Votre offre maximale était dans le mauvais incrément. Veuillez saisir une offre maximale sur ce véhicule par tranches de {proxyIncrement}',
  'vdp.error.placingBid': "Nous n'avons pu placer l’offre sur cette vente.",
  'vdp.error.placingProxy':
    "Nous n'avons pu placer l’offre maximale sur cette vente.",
  'vdp.error.general':
    'Un problème est survenu lors de la récupération de toutes les données de cette vente, veuillez patienter ou essayer d’actualiser la page',
  'bidding.error.unauthorized': "Désolé! Vous n’avez pas le droit d'enchérir.",
  'bidding.error.invalidAmount':
    'L’augmentation de votre offre n’est pas chiffrée en incréments valides. Veuillez saisir un montant par incréments de 50 $ pour les offres inférieures à 1000 $, ou par incréments de 100 $ pour celles supérieures à 1000 $.',
  'bidding.error.someoneElseBid':
    'Une autre personne a offert ce montant juste avant vous.',

  // Toaster Success Messages
  'vdp.success.bidPlaced': 'Votre offre a bien été placée.',
  'vdp.success.proxySet':
    'Votre offre maximale de {proxyAmount} a été fixée. Vous pouvez la modifier si vous le souhaitez.',
  'vdp.success.vinCopied': 'NIV copié dans le presse-papiers',

  // VDP Header
  'vdp.launchTime.active.today': 'Lancé aujourd’hui à {time}',
  'vdp.launchTime.yesterday': 'Lancé hier à {time}',
  'vdp.launchTime.upcoming.today': "Lancement aujourd'hui a {time}",
  'vdp.launchTime.upcoming.today.sale': "Aujourd'hui au {time}",
  'vdp.launchTime.tomorrow': 'Lancement demain à {time}',
  'vdp.launchTime.tomorrow.sale': 'Demain à {time}',
  'vdp.launchTime.future': 'Lancera le {date} à {time}',
  'vdp.launchTime.future.sale': '{date} à {time}',
  'vdp.launchTime.past': 'Lancé le {time}',
  'vdp.expirationTime.pending.today':
    'Période En Attente se termine aujourd’hui à {time}',
  'vdp.expirationTime.pending.tomorrow':
    'Période En Attente se termine demain à {time}',
  'vdp.expirationTime.pending.future':
    'Période En Attente se termine le {date} à {time}',
  'vdp.watch': 'Regarder',
  'vdp.watched': 'Regardé',
  'vdp.close': 'FERMER',
  'vdp.share': 'Partagé le véhicule',

  // VDP Overview
  'vdp.overview.vin': 'NIV',
  'vdp.overview.copyVin': 'Copier le NIV:',
  'vdp.overview.transmissionDriveTrain': 'Groupe motopropulseur',
  'vdp.overview.dateExpected': 'Date prévue',
  'vdp.overview.specsFeatures': 'Spécifications et caractéristiques complètes',
  'vdp.overview.make': 'Marque',
  'vdp.overview.model': 'Modèle',
  'vdp.overview.trim': 'Série',
  'vdp.overview.color': 'Couleur extérieure/intérieure',
  'vdp.overview.seats': 'Sièges',
  'vdp.overview.vehicleFeatures': 'Caractéristiques du véhicule',
  'vdp.overview.viewAll': 'Tout afficher',
  'vdp.overview.media.overview': 'Aperçu',
  'vdp.overview.media.disclosure': "Divulgation d'une information",
  'vdp.overview.media.videos': 'Vidéos',
  'vdp.overview.media.open': 'Multimédia ouvert',
  'vdp.overview.tradeId': 'Numéro du Véhicule',
  'vdp.overview.rateInfo.noQuote': 'Aucun devis disponible',
  'vdp.overview.rateInfo.promoRateInfo':
    'Infos sur les tarifs de transport promotionnels',
  'vdp.overview.rateInfo.rateInfo': 'Infos tarifs de transport',

  // VDP Multimedia
  'vdp.multimedia.title': 'Multimédia',
  'vdp.multimedia.disclosureImages': 'Images de divulgation',
  'vdp.multimedia.overviewImages': 'Aperçu des images',
  'vdp.multimedia.video': 'Vidéo',
  'vdp.multimedia.header.esc': 'Appuyez sur la clé <esc>esc</esc> pour ',
  'vdp.multimedia.interiordamage': 'Dommage Intérieur',
  'vdp.multimedia.exteriordamage': 'Dommage Extérieur',

  // VDP Bid
  'vdp.bid.tradeState.active': 'Actif',
  'vdp.bid.tradeState.upcoming': 'À Venir',
  'vdp.bid.tradeState.pending': 'En Attente',
  'vdp.bid.tradeState.closing': 'Fermeture',
  'vdp.bid.tradeState.won': 'Vendu',
  'vdp.bid.tradeState.arrived': 'Reçu',
  'vdp.bid.tradeState.delivered': 'Récupéré',
  'vdp.bid.tradeState.lost': 'Non Vendu',
  'vdp.bid.proxyAmount': 'Offre maximale (proxy)',
  'vdp.bid.startingBid': 'Offre de départ',
  'vdp.bid.auctionLaunched': 'Encan démarré',
  'vdp.bid.bidAmount': 'Montant de l’enchère',
  'vdp.bid.currentBidAmount': 'Montant de l’offre actuelle',
  'vdp.bid.beFirst': 'Soyez le premier à enchérir!',
  'vdp.bid.noBids': "Pas d'offre pour le moment",
  'vdp.bid.timeLeft.countdown.seconds': '{seconds}s',
  'vdp.bid.timeExtended': 'Prolongée',
  'vdp.bid.under30s': 'Moins de 30s',
  'vdp.bid.left': 'restantes',
  'vdp.bid.timeLeft': 'Moins de {time} {unit}',
  'vdp.bid.timeLeft.countdown': '{minutes}min {seconds}s',
  'vdp.bid.timeLeft.countdown.minutes': '{minutes}min',
  'vdp.bid.under1Min': 'Moins de 1 min',
  'vdp.bid.pendingVHR':
    'Le rapport d’historique de ce véhicule est toujours en attente.',
  'vdp.bid.floorPrice': 'Prix plancher: {floorPrice}',
  'vdp.bid.fullHistory': 'Historique complet',
  /* TODO: French translation */
  'vdp.bid.fullBidHistory': 'Full bid history',
  'vdp.bid.numberOfBids':
    '{numberOfBids, plural, one {# offre} other {# offres}}',
  'vdp.bid.yourBid': 'Votre enchère',
  'vdp.bid.placedDaysAgo':
    '{daysAgo, plural, one {Il y a # jour} other {il y a # jour(s)}}',
  'vdp.bid.placedHoursAgo':
    '{hoursAgo, plural, one {Il y a # heure} other {il y a # heure(s)}}',
  'vdp.bid.placedMinutesAgo':
    '{minsAgo, plural, one {Il y a # min} other {il y a # minute(s)}}',
  'vdp.bid.button.bid': 'Enchérir',
  'vdp.bid.button.placeBid': 'Miser',
  'vdp.bid.button.setProxy': 'Fixer offre maximale',
  'vdp.bid.currentBid': 'Montant de l’offre',
  'vdp.bid.button.setProxyAmount': 'Fixer proxy {proxyAmount}',
  'vdp.bid.button.setProxyAndBidAmount':
    'Enchérir {bidAmount} et fixer votre offre maximale {proxyAmount}',
  'vdp.bid.button.editProxy': "Modifier l'offre maximale",
  'vdp.bid.button.editProxyAmount': 'Modifier l’offre maximale a {proxyAmount}',
  'vdp.bid.button.quick.min.bid': 'Offre min',
  'vdp.bid.proxyMessage':
    "Offre maximale (proxy) : Nous enchérissons juste assez pour que vous restiez le meilleur enchérisseur, jusqu'à concurrence de votre offre maximale.",
  'vdp.bidModal.form.setProxy': 'Fixer le montant de l’enchère par procuration',
  'vdp.bidOverview.form.setProxy': 'Fixer offre maximale',
  'vdp.bid.editBidAmount': 'Éditer',
  'vdp.bid.no.payment.method.message':
    'Ce concessionnaire ne dispose pas de mode de paiement à son dossier.',
  'vdp.bid.add.payment.method':
    'Ajouter maintenant un compte bancaire sous les Paramètres',

  // VDP Inner Nav
  'vdp.innerNav.overview': 'Aperçu',
  'vdp.innerNav.condition': 'État',
  'vdp.innerNav.history': 'Historique',
  'vdp.innerNav.transportSeller': 'Transport et vendeur',
  'vdp.innerNav.research': 'Analyse de Prix',

  // VDP Conditions Disclosures
  'vdp.conditions.title': 'État',
  'vdp.conditions.thirdPartyInspected': 'Inspecté par un tiers',
  'vdp.conditions.seeChecklist': 'Voir la liste de contrôle',
  'vdp.conditions.nothingReported': 'Rien n’a été signalé',
  'vdp.conditions.inspectionDealerNotes':
    'Inspection et notes du concessionnaire',
  'vdp.conditions.alwaysReadNotes':
    'Toujours lire et examiner toutes les notes avant d’enchérir.',
  'vdp.conditions.noNotes': 'Aucune note fournie.',

  // VDP History
  'vdp.history.title': 'Résumé de l’historique',
  'vdp.history.alwaysViewReport':
    'Toujours consulter le rapport {reportType} avant d’enchérir',
  'vdp.history.waitingVHR': 'En attente du rapport d’historique du véhicule.',
  'vdp.history.viewButton': 'Voir',
  'vdp.history.noneReported': 'Aucun signalé',

  // VDP Transport details
  'vdp.transport.Details': 'Détails de transport',
  'vdp.transport.Disclosures': 'Informations de transport',
  'vdp.transport.NothingReported': 'Rien n’a été signalé',
  'vdp.transport.NotAvailable': 'Indisponible',
  'vdp.transport.NotDriveable':
    'Non-éligible pour conduite par chauffeurs{delimeter}',
  'vdp.transport.NotDriveableDiscTitle':
    'Ce véhicule n’est pas en état d’être opéré.',
  'vdp.transport.IsOversized': 'Est surdimensionné',
  'vdp.transport.DateExp': 'Date prévue',
  'vdp.transport.Estimate': 'Devis de transport',
  'vdp.transport.PromoOn': 'Promotion en cours!',
  'vdp.transport.PromoInfo': 'Informations sur la promotion',
  'vdp.transport.VehicleLocation': 'Emplacement du véhicule',
  'vdp.transport.estimateNotAvailable':
    "Le devis de transport n'est pas disponible pour ce véhicule en ce moment.",
  'vdp.transport.estimate':
    'Transport {startsWithVowel, select, true {d’} other {de }}{city}, {province}, à votre emplacement: ',
  'vdp.transport.hasDateExpectedExceededLimit':
    'La date prévue est à plus de {dateExpectedDaysLimit} jours du lancement',
  'vdp.transport.estimateWithStreet':
    'à {street}, {city}, {province}, {postalCode}',

  // VDP Seller Info
  'vdp.seller.heading': 'Informations du vendeur',
  'vdp.seller.qa': 'Questions et réponses',
  'vdp.seller.qaButton': 'Ouvrir Q&R',
  'vdp.seller.dealer': 'Concessionnaire vendeur',
  'vdp.seller.answers':
    '{chatCount, plural, one {# question et réponse} other {# questions et réponses}}',
  'vdp.seller.ratings': '({ratingsCount, plural, one {# avis} other {# avis}})',
  'vdp.seller.network': 'Réseau:',
  'vdp.seller.payments': 'Paiements acceptés',
  'vdp.seller.noRatings': '(Pas encore d’évaluation)',

  // Research
  'vdp.research.heading': 'Analyse de Prix',
  'vdp.research.subheading':
    'Selon l’historique des ventes de véhicules similaires au cours des 90 derniers jours',
  'vdp.research.average': 'Prix moyen',
  'vdp.research.highest': 'Plus élevé',
  'vdp.research.lowest': 'Plus bas',
  'vdp.research.researchVin': 'Ouvrir ce NIV sous le Guide marché',
  'vdp.research.autoniq': 'Rechercher ce véhicule dans Autoniq',
  'vdp.research.autoniq.short': 'Recherche dans Autoniq',
  'vdp.research.no.marketguide.data.part1':
    'Il n’y a pas assez de données de marché de ventes en gros pour ',
  'vdp.research.no.marketguide.data.part2':
    'l’année, la marque, le modèle et la série ',
  'vdp.research.no.marketguide.data.part3':
    'de ce véhicule. Trouvez des véhicules comparables en allant sous le Guide du Marché et en étendant la plage d’années, ou en choisissant davantage de types de série.',

  // VDP Share Retail
  'vdp.retail.price.placeholder': 'Entrer prix client',
  'vdp.retail.description.placeholder': 'Entrer la description',
  'vdp.retail.share': 'Partager ce véhicule avec un client',
  'vdp.retail.shareUrl': "Partager l'URL de ce véhicule",
  'vdp.retail.message':
    "Créez une vue conviviale de cette page que vous contrôlez pour l'envoyer à un client potentiel.",
  'vdp.retail.link': 'Créer un lien client',
  'vdp.retail.noCarfax.title': 'Rapport CARFAX pas encore prêt',
  'vdp.retail.noCarfax.message':
    "Vous ne pouvez pas créer de lien client tant que le Rapport CARFAX n'a pas été ajouté à ce listage",
  'vdp.retail.vhr': "Rapport d'historique du véhicule",
  'vdp.retail.vhr.carfax':
    'Voir ci-dessous pour un lien vers le rapport CARFAX Canada de ce véhicule.',
  'vdp.retail.kilometres': 'Kilomètres',
  'vdp.retail.transmission': 'Boîte de vitesses',
  'vdp.retail.engine': 'Moteur',
  'vdp.retail.drivetrain': 'Chaîne cinématique',
  'vdp.retail.fuelType': 'Type de carburant',
  'vdp.retail.seats': 'Sièges',
  'vdp.retail.exteriorInterior': 'Couleur extérieure/intérieure',

  // Footer
  'vdp.footer.findMore': 'Trouvez d’autres véhicules sous {tradeState}',
  'vdp.footer.backTo': 'Retour à {tradeState}',

  // Mini VDP
  'mini.vdp.nothing.selected.heading': 'Aucun Véhicule sélectionné.',
  'mini.vdp.nothing.selected.subheading':
    'Choisir un véhicule à la gauche pour y voir les details et les mises.',

  // Modals
  'modal.yes': 'Oui',
  'modal.ok': 'D’accord',
  'modal.noThanks': 'Non, merci',
  'modal.cancel': 'Annuler',
  'modal.confirmation.loading': 'Chargement ...',
  'modal.confirmation.confirmYourBid.title':
    'Avez-vous lu la page de détails et le rapport d’historique de ce véhicule?',
  'modal.confirmation.confirmYourBid.description':
    'Nous ne poserons cette question qu’une seule fois pour ce véhicule - d’autres mises ne susciteront pas ce message.',
  'modal.submit': 'Soumettre',
  'auto.win.on.disclaimer':
    "Gagner automatiquement est activé : Nous utiliserons votre montant par procuration pour essayer de gagner si le prix plancher n'est pas atteint ou lors d'une négociation.",

  // Tooltips
  'tooltips.isFloorPriceMet':
    'Le prix plancher a été atteint, la vente de ce véhicule est garantie.',
  'tooltips.hasFloorPrice':
    'Si le prix plancher du vendeur est atteint, la vente de ce véhicule sera garantie.',
  'tooltips.isCloseToFloorPrice':
    "L'offre actuelle est presque au prix plancher du vendeur - continuez à enchérir!",

  // List Header, Footer & Empty state
  'list.footer.sell.looking.pending':
    "Vous cherchez d'autres véhicules ? Vous pourriez en trouver sous les statuts Fermeture ou Reçu ?",
  'list.header.buy.pending.negotiations.subheading':
    'Les négociations infructueuses déplaceront les véhicules sous Non Vendu.',
  'list.modal.pending.moveToClosing.confirm.message':
    "Vous ne pouvez pas envoyer ce véhicule à l’encan sous Fermeture puisqu’il n’y a qu’un seul enchérisseur. Acceptez l'offre finale de {acv} $ et déplacez ce véhicule vers Vendu?",
  'list.modal.pending.moveToLost.confirm.confirm': 'Passer En Mode Non vendu',
  'list.modal.pending.moveToLost.confirm.error':
    'Un problème est survenu au moment de passé le véhicule au mode Non vendu',
  'list.modal.pending.moveToLost.confirm.success':
    'La voiture a été envoyée à Non vendu.',
  'list.modal.pending.moveToLost.confirm.title':
    'Terminer Encan et marquer véhicule Non vendu',
  'list.modal.pending.openNetwork.park.confirm.message':
    'Lorsque vous Garez cet échange, la version du réseau de groupe de concessionnaires de cet échange sera déplacée vers Non vendu.',
  'list.openTrade.dgn.negotiateFirst.error.message':
    "Vous devez d'abord négocier sur le réseau d'échange du groupe de concessionnaires. Si vous ne voulez pas négocier, marquez-le comme Non vendu. Lorsque la version du réseau de groupe de concessionnaires de cet échange est marquée Perdue, vous pourrez négocier sur cet échange.",

  // Toaster
  'toaster.dismiss.message': 'Rejeter',

  // Card
  'list.card.negotiation.topBid': 'Meilleure offre',
  'list.card.negotiation.sendClosing': 'Envoyer à l’encan sous Fermeture',

  // Negotiation modals
  'modal.decision.sendToClosing.message.dgnTrade':
    "Les deux meilleurs enchérisseurs continueront d'enchérir jusqu'à ce qu'il y ait un gagnant. La version Réseau ouvert de cet échange sera envoyée à Non vendu.",
  'modal.decision.sendToClosing.message.openTrade':
    "Les deux meilleurs enchérisseurs continueront d'enchérir jusqu'à ce qu'il y ait un gagnant. La version réseau du groupe de concessionnaires de cet échange sera envoyée à Non vendu.",
  'modal.negotiation.accept.description':
    "Cela mettra fin aux négociations et fera passer ce véhicule en mode Vendu ou Reçu s'il est en inventaire.",
  'modal.negotiation.decline.seller.description.msg2':
    "Si vous ne souhaitez pas continuer l'enchère, envoyez le véhicule à Non vendu.",
  'modal.negotiation.decline.seller.sendToLost': 'Envoyer vers Non vendu',
  'modal.negotiation.stayFirm': 'Rester Ferme',
  'modal.negotiation.tutorial.seller.dgn.firstReply.message1':
    'Si la négociation réussit, le véhicule passera à Vendu ou Reçu.',
  'modal.negotiation.tutorial.seller.dgn.message1':
    "Si la négociation aboutit, le véhicule passera à Vendu ou Reçu s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.dgn.message2':
    "Si vous ou l'acheteur refusez la négociation, ce véhicule en Réseau Groupe Concessionnaires passera en mode Non vendu.",
  'modal.negotiation.tutorial.seller.message0':
    "Si la négociation est concluante, le véhicule passera en mode Vendu ou Reçu, s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.open.start.message0':
    "Si la négociation aboutit, le véhicule passera à Vendu ou Reçu s'il est en inventaire.",
  'modal.negotiation.tutorial.seller.open.start.message1':
    "Si vous ou l'acheteur refusez la négociation, ce véhicule en Réseau Ouvert passera en mode Non vendu.",
  'negotiation.send.to.lost': 'Envoyer vers Non vendu',

  // TradeStates
  'tradeState.won': 'Vendu',
  'tradeState.arrived': 'Reçu',
  'tradeState.delivered': 'Récupéré',
  'tradeState.lost': 'Non Vendu',

  // Retail Tools Setting
  'retail.tools.setting': 'Outils pour vente au détail',
  'retail.tools.setting.description':
    "Personnalisez le contenu auquel votre clientèle aura accès, en utilisant les liens rapides de l'Échange à Domicile et la PDV pour client",
  'retail.tools.setting.heading': 'Renseignements du concessionnaire',
  'retail.tools.setting.heading.description':
    'La modification des paramètres ici mettra également à jour tous les liens précédemment générés par ce concessionnaire.',
  'retail.tools.setting.upload.logo': 'Téléverser le logo',
  'retail.tools.setting.upload.logo.for': 'Téléverser le logo pour',
  'retail.tools.setting.edit.logo': 'Modifier le logo',
  'retail.tools.setting.edit.logo.for': 'Modifier le logo pour',
  'retail.tools.setting.upload.logo.description':
    "Le logo du concessionnaire apparaîtra pour votre clientèle sur la page de destination de l'Inspection.",
  'retail.tools.setting.upload.logo.error': 'Un problème est survenu.',
  'retail.tools.setting.logo.note':
    '<b>REMARQUE :</b> les images seront acceptées en format .PNG/.JPEG, de préférence avec un fond transparent.',
  'retail.tools.setting.logo.size':
    'Les images doivent avoir un minimum de 500 x 500 pixels et moins de 15 Mo.',
  'retail.tools.setting.tiah.heading': "Page de renvoi de l'Échange à Domicile",
  'retail.tools.setting.tiah.heading.for':
    'Page d’accueil de l’Inspection au Détail pour',
  'retail.tools.setting.tiah.description':
    "Cette page est celle que voit votre clientèle dès qu'elle ouvre le lien d'invitation envoyé par votre concessionnaire. Cette page se situe sous la rubrique Vente / Créer.",
  'retail.tools.setting.retailVdp.heading':
    'Info sur le rapport de condition au détail',
  'retail.tools.setting.retailVdp.heading.for':
    'Informations pour le rapport de condition au détail',
  'retail.tools.setting.retailVdp.description':
    'Ces informations seront préremplies lorsque vous partagerez un véhicule. Vous pouvez également en changer le contenu, si vous le souhaitez, à ce moment-là.',
  'retail.tools.setting.retailVdp.inventory.disclaimer':
    "Si le client n'est pas intéressé par le véhicule que vous lui proposez, nous lui indiquerons un lien vers votre inventaire de véhicules d'occasion.",
  'retail.tools.setting.warning': 'Avertissement',
  'retail.tools.setting.logo.upload.error':
    'L’image que vous avez essayé de téléverser ne répond pas aux exigences. Essayez à nouveau.',
  'retail.tools.setting.warning.message':
    "La mise à jour de ces paramètres modifiera également l'apparence de tous les liens précédemment générés par ce concessionnaire.",
  'list.filters.save': 'Sauvegarder',
  'list.filters.add.logo': 'Ajouter le logo',
  'list.filters.edit.details': 'Modifier les détails',
  'retail.tools.setting.confirmation':
    'Vos configurations ont été sauvegardées. Les mises à jour sont maintenant en temps réel sous vos outils de vente au détail!'
};
